import { string, object, ObjectSchema, array } from 'yup';

import {
  EMAIL_VALIDATION_REGEX,
  ERROR_INVALID_EMAIL,
  ERROR_REQUIRED_FIELD_WITH_NAME,
} from '@/constants';

import { createNameofProxy } from '@/lib/ui/form';

import { IUserCreation } from '@/features/user-management/user-management-creation/interfaces';

const ERROR_REQUIRED_ROLES = ERROR_REQUIRED_FIELD_WITH_NAME('At least one Role');

export const USER_CREATION_SCHEMA = object({
  fullName: string().required(ERROR_REQUIRED_FIELD_WITH_NAME('User Name')),
  email: string()
    .required(ERROR_REQUIRED_FIELD_WITH_NAME('ST Engineering email'))
    .matches(EMAIL_VALIDATION_REGEX, ERROR_INVALID_EMAIL),
  roles: array().of(string()).required(ERROR_REQUIRED_ROLES).min(1, ERROR_REQUIRED_ROLES),
}) as ObjectSchema<IUserCreation>;

export const USER_CREATION_FORM_FIELDS = createNameofProxy<IUserCreation>();
